import { createAction, createSlice } from "@reduxjs/toolkit";
import { CollaboratorSlice, Collaborator, CollaboratorFilter, DataUpdateColabborator } from "../type";
import { RootState } from "store/store";

const initialState: CollaboratorSlice = {
	total: 0,
	list: [],
	detail: null,
	appointments: [],
	purchases: [],
};

export const collaboratorSlice = createSlice({
	name: "collaborator",
	initialState,
	reducers: {
		setCollaborators: (state, action) => {
			state.list = action.payload.data;
			state.total = action.payload.total;
		},
		setCollaborator: (state, action) => {
			state.detail = action.payload;
			if (action.payload !== null) {
				state.list = state.list.map(collab => {
					if (collab._id === action.payload._id) return action.payload;
					return collab;
				});
			}
		},
	},
});

export const { setCollaborators, setCollaborator } = collaboratorSlice.actions;

export const selectCollaboratorTotal = (state: RootState) =>
	state.collaborator.total;
export const selectCollaborators = (state: RootState) =>
	state.collaborator.list;
export const selectCollaborator = (state: RootState) =>
	state.collaborator.detail;

export default collaboratorSlice.reducer;

export interface GetCollaboratorsPayload {
	query: CollaboratorFilter;
	callback?: () => void;
}
export const getCollaboratorsAsync = createAction(
	"collaborator/getCollaboratorsAsync",
	(payload: GetCollaboratorsPayload) => ({
		payload,
	}),
);

export interface GetCollaboratorPayload {
	id: string;
	callback?: () => void;
}
export const getCollaboratorAsync = createAction(
	"collaborator/getCollaboratorAsync",
	(payload: GetCollaboratorPayload) => ({
		payload,
	}),
);

export interface RejectCollaboratorPayload {
	id: string;
	reason: {
		message: string;
		samepleId: string;
	};
	callback?: () => void;
}

export const rejectCollaboratorAsync = createAction(
	"collaborator/rejectCollaboratorAsync",
	(payload: RejectCollaboratorPayload) => ({
		payload,
	}),
);

export interface BlockCollaboratorPayload {
	id: string;
	reason: {
		message: string;
		samepleId: string;
	};
	callback?: () => void;
}

export const blockCollaboratorAsync = createAction(
	"collaborator/blockCollaboratorAsync",
	(payload: BlockCollaboratorPayload) => ({
		payload,
	}),
);

export interface ApproveCollaboratorPayload {
	id: string;
	callback?: () => void;
}

export const approveCollaboratorAsync = createAction(
	"collaborator/approveCollaboratorAsync",
	(payload: ApproveCollaboratorPayload) => ({
		payload,
	}),
);

export interface UpdateCollaboratorPayload {
	data: DataUpdateColabborator;
	callback?: () => void;
}

export const updateCollaboratorAsync = createAction(
	"collaborator/updateCollaboratorAsync",
	(payload: UpdateCollaboratorPayload) => ({
		payload,
	}),
);
